import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function WestPomeranian() {
  return (
    <>
      <DisplayMaster voivodeship="WestPomeranian" />
    </>
  );
}